<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar></navbar>
			<!--导航-->
			<!--引导块-->
			<div
				v-if="infoData"
				class="tips_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tips_main">
					<span>Home&nbsp;&nbsp;>&nbsp;&nbsp;Products&nbsp;&nbsp;>&nbsp;&nbsp;{{ infoData.parent_name }}&nbsp;&nbsp;>&nbsp;&nbsp;</span>{{ infoData.title }}
				</div>
			</div>
			<!--引导块-->
			<!--banner-->
			<div v-if="infoData" class="banner_box">
				<div class="banner_main">
					<div class="top"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<span class="tit1 font1">CorDx Tyfast</span>&ensp;&ensp;<span class="tit2 font2">Flu A/B & COVID-19</span>
					</div>
					<div class="banner_main_main">
						<div class="left"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="200"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div class="title">Multiplex Rapid Test (OTC)</div>
							<div class="desc">
								CorDx Tyfast Flu A/B & COVID-19 At Home
								Multiplex Rapid Test provides accurate Flu A/B
								and COVID-19 detection in 10 minutes for quick,
								reliable home health assessments.
							</div>
							<div class="list_box">
								<div class="list_el">
									<img src="../../assets/20261104poc/nose.png" />
									<div>Nasal Swab</div>
								</div>
								<div class="list_el">
									<img src="../../assets/20261104poc/friendly.png" />
									<div>User-Friendly</div>
								</div>
							</div>
							<div class="btn_box">
								<img src="../../assets/20261104poc/buy_now_button.png" @click="goAl21" />
							</div>
						</div>
						<div class="right"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<van-image width="100%" height="auto" :src="require('@/assets/20261104poc/products.png')" />
						</div>
					</div>
					<img class="rz" src="../../assets/20261104poc/fda.png"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					/>
				</div>
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1">
				<div class="block_1_main">
					<div class="list_box">
						<div class="list_el"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="500"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<img src="../../assets/20261104poc/clock-stopwatch.png" />
							<div>Rapid Results</div>
						</div>
						<div class="list_el"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="800"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<img src="../../assets/20261104poc/face-smile.png" />
							<div>Noninvasive</div>
						</div>
						<div class="list_el"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="1100"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<img src="../../assets/20261104poc/rocket-02.png" />
							<div>Streamlined</div>
						</div>
						<div class="list_el"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="1400"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<img src="../../assets/20261104poc/check-circle-broken.png" />
							<div>Quality</div>
						</div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2">
				<div class="block_2_main">
					<div class="title_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="title">‌FEATURES AND BENEFITS</div>
						<div class="tips">////////////////////////////////////////////////////////////////////////</div>
					</div>
					<div class="msg_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="msg_el">
							<div class="tips">·</div>
							<div class="txt">
								<span>FDA 510(k):</span> K262432
							</div>
						</div>
						<div class="msg_el">
							<div class="tips">·</div>
							<div class="txt">
								<span>3-in-1 Multiplex Detection:</span> Detects SARS-CoV-2, Influenza A, and Influenza B
								antigens from a single anterior nasal swab sample.
							</div>
						</div>
						<div class="msg_el">
							<div class="tips">·</div>
							<div class="txt">
								<span>Designed for Symptomatic Testing:</span> Intended for individuals experiencing symptoms of respiratory infection within the first 5 days of symptom onset.
							</div>
						</div>
						<div class="msg_el">
							<div class="tips">·</div>
							<div class="txt">
								<span>Simple, Instrument-free Testing:</span> Straightforward test process with visually read results in just 10 minutes.
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3">
				<div class="block_3_main">
					<div class="title_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="title">‌WHATS INSIDE</div>
						<div class="tips">//////////////////////////////////////////////////////////////////////////////////////</div>
					</div>
					<div class="msg_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="tips">Ref #: ACT21004-{{ active }}</div>
						<div class="img_box">
							<img class="img_el" width="auto" height="auto" :src="activeUrl" />
						</div>
						<div class="title">Flu A/B & COVID-19 Mulitplex Rapid Test Rx Cassette</div>
						<div class="list_box">
							<div class="bt">Package Size</div>
							<div
								v-for="(value, index) in gzList"
								:key="index"
								class="list_el"
								:class="active == value.num ? 'active' : ''"
								@click="checkGuide(value)"
							>
								{{ value.title }}
							</div>
							<div class="tit"><span>·</span>&ensp;{{ active }} Test cassettes</div>
							<div class="tit"><span>·</span>&ensp;{{ active }} Tube with sample processing solutions</div>
							<div class="tit"><span>·</span>&ensp;{{ active }} Swabs</div>
							<div class="tit"><span>·</span>&ensp;1 Instructions for use</div>
							<div class="btn_box">
								<img @click="goBuyUrl" src="../../assets/20261104poc/Button.png" />
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块3-->
			<!--块4-->
			<div class="block_4">
				<div class="block_4_main">
					<div class="title_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="title">PERFORMANCE SPECIFICATION‌</div>
						<div class="tips">/////////////////////////////////////////////////////////////////</div>
					</div>
					<div class="table_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<el-table :data="tableData" :span-method="objectSpanMethod" border style="width: 100%">
							<el-table-column prop="data1" label="" align="" width=''></el-table-column>
							<el-table-column prop="data2" label="COVID-19" align="center" width='120'></el-table-column>
							<el-table-column prop="data3" label="Flu A" align="center" width='100'></el-table-column>
							<el-table-column prop="data4" label="Flu B" align="center" width='100'></el-table-column>
							<el-table-column prop="data5" label="Storage Temperature" align="center" width=''></el-table-column>
							<el-table-column prop="data6" label="Time to Result" align="center" width='170'></el-table-column>
							<el-table-column prop="data7" label="Shelf Life" align="center" width='125'></el-table-column>
						</el-table>
					</div>
				</div>
			</div>
			<!--块4-->
			<!--块5-->
			<div class="block_5">
				<div class="block_5_main">
					<div class="title_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="title">TEST PROCEDURE</div>
						<div class="tips">/////////////////////////////////////////////////////////////////////////////////</div>
					</div>
					<div class="list_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="list_el">
							<img class="bg" src="../../assets/20261104poc/step_1.png" />
						</div>
						<div class="list_el">
							<img class="bg" src="../../assets/20261104poc/step_2.png" />
						</div>
						<div class="list_el">
							<img class="bg" src="../../assets/20261104poc/step_3.png" />
						</div>
					</div>
					<div class="list_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="list_el">
							<img class="bg" src="../../assets/20261104poc/step_4.png" />
						</div>
						<div class="list_el">
							<img class="bg" src="../../assets/20261104poc/step_5.png" />
						</div>
						<div class="list_el">
							<img class="bg" src="../../assets/20261104poc/step_6.png" />
						</div>
					</div>
				</div>
			</div>
			<!--块5-->
			<!--块6-->
			<div class="block_6">
				<div class="block_6_main">
					<div class="title_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="title">TEST RESULTS‌</div>
						<div class="tips">//////////////////////////////////////////////////////////////////////////////////////</div>
					</div>
					<div class="list_box">
						<div class="list_el"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="300"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div class="left" style="width: 540px;text-align: left;">
								<img src="../../assets/20261104poc/positive_result.png" />
							</div>
							<div class="right">
								<div class="title">Positive</div>
								<div class="text">
									If the control line (C) is visible and one or more lines
									appear(s) for any of the viruses, the test is positive for that
									or those viruses.
								</div>
								<div class="text">
									<span>NOTE:</span> Any red line, no matter how faint, should be considered an indication of a positive result.
								</div>
							</div>
						</div>
						<div class="list_el"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="500"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div class="left">
								<img src="../../assets/20261104poc/negative_results.png" />
							</div>
							<div class="right">
								<div class="title">Negative</div>
								<div class="text">
									If the control line (C) is visible, but no other lines appear the test is negative.
								</div>
							</div>
						</div>
						<div class="list_el"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="700"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div class="left">
								<img src="../../assets/20261104poc/invalid_results.png" />
							</div>
							<div class="right">
								<div class="title">Invalid</div>
								<div class="text">
									If the control line (C) is not visible the test is invalid, even if any test line is visible.
									Re-test with a new swab and new test device.
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块6-->
			<!--块7-->
			<div class="block_7">
				<div class="block_7_main">
					<div class="title_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="title">‌WANT TO KNOW MORE?‌‌</div>
						<div class="tips">//////////////////////////////////////////////////////////////////////////</div>
					</div>
					<div class="list_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<el-collapse accordion>
							<van-collapse v-model="activeNames" :border="false" @change="collChange">
								<van-collapse-item :name="1" :border="false">
									<template #title>
										<div class="title_box">
											<div class="tit">1. Guide Download</div>
										</div>
									</template>
									<template #right-icon>
										<div class="img">
											<img v-if="nowActived.length > 1 || nowActived[0] == 1" src="../../assets/20261104poc/minus-circle.png" />
											<img v-else src="../../assets/20261104poc/plus-circle.png" />
										</div>
									</template>
									<div class="content">
										<div class="content_el" @click="downloadUrl(2)">
											<img src="../../assets/rsv/6.webp" />&ensp;<span>Download QRI</span>
										</div>
									</div>
								</van-collapse-item>
								<van-collapse-item :name="2" :border="false">
									<template #title>
										<div class="title_box">
											<div class="tit">2. Product Sale Sheet</div>
										</div>
									</template>
									<template #right-icon>
										<div class="img">
											<img v-if="nowActived.length > 1 || nowActived[0] == 2" src="../../assets/20261104poc/minus-circle.png" />
											<img v-else src="../../assets/20261104poc/plus-circle.png" />
										</div>
									</template>
									<div class="content">
										<div class="content_el" @click="downloadUrl(3)">
											<img src="../../assets/rsv/6.webp" />&ensp;<span>Download sale sheet</span>
										</div>
									</div>
								</van-collapse-item>
							</van-collapse>
						</el-collapse>
					</div>
					<div class="goTop"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						@click="goTop"
					>
						<img src="../../assets/COT/top.webp" />
						<div class="tit">BACK TO TOP</div>
					</div>
				</div>
			</div>
			<!--块7-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import fixed from '@/component/pc/fixed.vue'  //联系我们悬浮
import { productInfo, productCount } from '@/api/public';
import md5 from 'js-md5';
import moment from 'moment';
import download from 'downloadjs';
export default {
	components:{
		navbar,
		footerBox,
		fixed
	},
	metaInfo() {
		return {
			meta: [
				{
					name: "description",
					content: this.metaDescription,
				},{
					name: "keywords",
					content: this.metaKeywords,
				}
			]
		}
	},
	data() {
		return {
			isLoading: true,  //界面loading
			infoData: null,
			metaDescription: '',
			metaKeywords: '',
			gzList: [
				{ 
					num: 1,
					title: '1 Test',
					imgUrl: require('@/assets/20261104poc/1T_510k_otc.jpg'),
					buyUrl: 'https://al21.com/products/cordx-tyfast-3-in-1-flu-a-b-covid-19-rapid-test-kit-510k?open_in_browser=true'
				},
				{
					num: 2,
					title: '2 Tests',
					imgUrl: require('@/assets/20261104poc/2T_510k_otc.jpg'),
					buyUrl: 'https://al21.com/products/cordx-tyfast-3-in-1-flu-a-b-covid-19-rapid-test-kit-510k?variant=54386341871909'
				},
				{ 
					num: 4,
					title: '4 Tests',
					imgUrl: require('@/assets/20261104poc/4T_510k_otc.jpg'),
					buyUrl: 'https://al21.com/products/cordx-tyfast-3-in-1-flu-a-b-covid-19-rapid-test-kit-510k?variant=54386341937445'
				},
				{ 
					num: 5,
					title: '5 Tests',
					imgUrl: require('@/assets/20261104poc/5T_510k_otc.jpg'),
					buyUrl: 'https://al21.com/products/cordx-tyfast-3-in-1-flu-a-b-covid-19-rapid-test-kit-510k?variant=54386341970213'
				},
				{ 
					num: 10,
					title: '10 Tests',
					imgUrl: require('@/assets/20261104poc/10T_510k_otc.jpg'),
					buyUrl: 'https://al21.com/products/cordx-tyfast-3-in-1-flu-a-b-covid-19-rapid-test-kit-510k?variant=54386342002981'
				},
				{ 
					num: 25,
					title: '25 Tests',
					imgUrl: require('@/assets/20261104poc/25T_510k_otc.jpg'),
					buyUrl: 'https://al21.com/products/cordx-tyfast-3-in-1-flu-a-b-covid-19-rapid-test-kit-510k?variant=54386342035749'
				}
			],
			active: 1,
			activeUrl: require('@/assets/20261104poc/1T_510k_otc.jpg'),
			activeBuyUrl: 'https://al21.com/products/cordx-tyfast-3-in-1-flu-a-b-covid-19-rapid-test-kit-510k?open_in_browser=true',
			tableData: [
				{
					data1: 'Positive Percent Agreement(PPA)',
					data2: '92.2%',
					data3: '86.5%',
					data4: '86.1%',
					data5: '2-30°C/ 36-86°F',
					data6: '10 minutes',
					data7: '24 months'
				}, {
					data1: 'Negative Percent Agreement(NPA)',
					data2: '100%',
					data3: '99.8%',
					data4: '100%',
					data5: '2-30°C/ 36-86°F',
					data6: '10 minutes',
					data7: '24 months'
				}
			],
			nowActived: [1, 2],
			activeNames: [1, 2],
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		//请求产品信息
		productInfo({
			custom: that.$route.name
		}).then(res => {
			that.infoData = res.data;
			document.title = res.data.title + ' - CorDx';
			that.metaDescription = res.data.description;
			that.metaKeywords = res.data.keywords;
			that.setOgTag('og:locale', 'en_US');
			that.setOgTag('og:title', res.data.title);
			that.setOgTag('og:description', res.data.description);
			that.setOgTag('og:image', res.data.url);
			that.setOgTag('og:image:width', '1200');
			that.setOgTag('og:image:height', '630');
			that.setOgTag('og:image:type', 'webp');
			that.isLoading = false;
			//统计访问
			// let time = String(moment(new Date()).valueOf());
			// setTimeout(() => {
			// 	productCount({
			// 		language: sessionStorage.getItem('lang') == 'en' ? 2 : 1,
			// 		cate_id: that.infoData.cate_id,
			// 		cert_id: that.infoData.cert_id,
			// 		productid: that.infoData.id,
			// 		url: that.$route.name,
			// 		addtime: time,
			// 		sign: md5(String(that.infoData.cate_id) + String(that.infoData.cert_id) + String(that.infoData.id) + that.$route.name + String(time) + 'CorDx2023'),
			// 	}).then(res2 => {});
			// }, 10000);
		});
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//变更产品规格
		checkGuide(value) {
			let that = this;
			if(value.num != that.active) {
				that.active = value.num;
				that.activeUrl = value.imgUrl;
				that.activeBuyUrl = value.buyUrl;
			}
		},
		//文件下载
		downloadUrl(value) {
			let that = this;
			switch(value) {
				case 1:
					download('');
				break;
				case 2:
					download('https://cordx.com/files/CorDx_510k_3in1_QRI-OTC.pdf');
				break;
				case 3:
					download('https://cordx.com/files/CorDx_510k_OTC_sale_sheet.pdf');
				break;
			}
		},
		//折叠面板点击
		collChange(activeNames) {
			let that = this;
			that.nowActived = activeNames;
		},
		isHas(id) {
			let that = this;
			if(that.nowActived.length > 0) {
				let str = null;
				that.nowActived.forEach((value, index) => {
					if(value == id) {
						str = 1;
					}
				});
				if(str == 1) {
					return true;
				}else {
					return false;
				}
			}else {
				return false;
			}
		},
		//设置OG标签
		setOgTag(property, content) {
			const meta = document.querySelector(`meta[property='${property}']`);
			if(meta) {
				meta.setAttribute('content', content);
			} else {
				const newMeta = document.createElement('meta');
				newMeta.setAttribute('property', property);
				newMeta.setAttribute('content', content);
				document.head.appendChild(newMeta);
			}
		},
		goAl21() {
			let that = this;
			window.open(that.infoData.buy_url);
		},
		goBuyUrl() {
			window.open(this.activeBuyUrl);
		},
		objectSpanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex >= 4) {
				if (rowIndex % 2 === 0) {
					return {
						rowspan: 2,
						colspan: 1
					};
				} else {
					return {
						rowspan: 0,
						colspan: 0
					};
				}
			}
		},
		goTop() {
			window.scrollTo({ top: 0, behavior: 'smooth' })
		}
	}
}
</script>

<style scoped lang="less">
.main_box{
	//块7
	.block_7{
		overflow: hidden;
		position: relative;
		.block_7_main{
			width: 1140px;
			margin: 0 auto;
			padding: 60px 0 0px 0;
			.goTop{
				.tit{
					padding-top: 10px;
					font-weight: bold;
					font-size: 48px;
					color: #18318E;
				}
				img{
					width: 80px;
				}
				padding: 100px 0 60px 0;
				text-align: center;
				cursor: pointer;
			}
			.list_box{
				padding-top: 20px;
				.img{
					img{
						width: 50px;
						position: relative;
						top: 22px;
					}
				}
				.content{
					padding: 0px 0 20px 0;
					.content_el{
						margin: 0px 0 24px 0;
						cursor: pointer;
						user-select: none;
						span{
							color: #000000;
							font-size: 24px;
							position: relative;
							top: 8px;
							left: 5px;
						}
						img{
							width: 42px;
						}
					}
				}
				.title_box{
					// border-bottom: 1px solid #969799;
					.tit{
						padding: 30px 0 30px 0;
						font-size: 36px;
						font-weight: bold;
						user-select: none;
						line-height: 1;
					}
				}
			}
			.title_box{
				display: flex;
				align-items: center;
				.title{
					width: auto;
					font-size: 32px;
					color: rgb(241, 96, 0);
					font-weight: bold;
				}
				.tips{
					flex: 1;
					padding-left: 30px;
					font-size: 30px;
					color: #EBEBEB;
				}
			}
		}
	}
	//块6
	.block_6{
		overflow: hidden;
		position: relative;
		.block_6_main{
			width: 1140px;
			margin: 0 auto;
			padding: 60px 0 0px 0;
			.list_box{
				padding: 40px 0 0px 0;
				.list_el{
					display: flex;
					padding: 24px 0;
					.right{
						flex: 1;
						padding-left: 50px;
						.text{
							padding-top: 10px;
							font-size: 22px;
							span{
								font-size: 22px;
								font-weight: bold;
							}
						}
						.title{
							font-size: 34px;
							font-weight: bold;
						}
					}
					.left{
						width: 270px;
						text-align: right;
						overflow: hidden;
						img{
							max-width: 100%;
						}
					}
				}
			}
			.title_box{
				display: flex;
				align-items: center;
				.title{
					width: auto;
					font-size: 32px;
					color: rgb(241, 96, 0);
					font-weight: bold;
				}
				.tips{
					flex: 1;
					padding-left: 30px;
					font-size: 30px;
					color: #EBEBEB;
				}
			}
		}
	}
	//块5
	.block_5{
		overflow: hidden;
		position: relative;
		.block_5_main{
			width: 1140px;
			margin: 0 auto;
			padding: 60px 0 0px 0;
			.list_box{
				display: flex;
				align-items: start;
				padding-top: 50px;
				.list_el{
					flex: 1;
					display: flex;
					padding-right: 80px;
					.bg{
						width: 100%;
					}
				}
			}
			.title_box{
				display: flex;
				align-items: center;
				.title{
					width: auto;
					font-size: 32px;
					color: rgb(241, 96, 0);
					font-weight: bold;
				}
				.tips{
					flex: 1;
					padding-left: 30px;
					font-size: 30px;
					color: #EBEBEB;
				}
			}
		}
	}
	//块4
	.block_4{
		overflow: hidden;
		position: relative;
		.block_4_main{
			width: 1140px;
			margin: 0 auto;
			padding: 60px 0 0px 0;
			.table_box{
				padding-top: 30px;
			}
			.title_box{
				display: flex;
				align-items: center;
				.title{
					width: auto;
					font-size: 32px;
					color: rgb(241, 96, 0);
					font-weight: bold;
				}
				.tips{
					flex: 1;
					padding-left: 30px;
					font-size: 30px;
					color: #EBEBEB;
				}
			}
		}
	}
	//块3
	.block_3{
		overflow: hidden;
		position: relative;
		.block_3_main{
			width: 1140px;
			margin: 0 auto;
			padding: 60px 0 0px 0;
			.msg_box{
				margin-top: 30px;
				padding: 100px 40px 40px 40px;
				border-radius: 24px;
				border: 1px solid #000000;
				position: relative;
				.list_box{
					padding-top: 10px;
					.btn_box{
						padding-top: 30px;
						img{
							width: 260px;
							cursor: pointer;
						}
					}
					.tit{
						padding-top: 8px;
						font-size: 24px;
						font-weight: bold;
						span{
							font-size: 30px;
							font-weight: bold;
							position: relative;
							top: 3px;
						}
					}
					.list_el{
						display: inline-block;
						margin: 0 10px 20px 10px;
						padding: 8px 24px 6px 24px;
						border-radius: 16px;
						border: 2.5px solid #aaaaaa;
						font-weight: bold;
						font-size: 24px;
						cursor: pointer;
					}
					.list_el.active{
						color: #016bb8;
						border: 2.5px solid #016bb8;
					}
					.bt{
						padding-bottom: 10px;
						color: #666666;
						font-size: 16px;
					}
				}
				.title{
					font-size: 28px;
					font-weight: bold;
				}
				.tips{
					position: absolute;
					top: 0;
					background: rgb(241, 96, 0);
					position: absolute;
					top: 0;
					width: auto;
					left: 0;
					padding: 6px 20px;
					border-radius: 24px 0px 24px 0px;
					font-size: 18px;
					color: #ffffff;
				}
				.img_box{
					padding-bottom: 50px;
					.img_el{
						max-width: 500px;
						max-height: 500px;
					}
				}
			}
			.title_box{
				display: flex;
				align-items: center;
				.title{
					width: auto;
					font-size: 32px;
					color: rgb(241, 96, 0);
					font-weight: bold;
				}
				.tips{
					flex: 1;
					padding-left: 30px;
					font-size: 30px;
					color: #EBEBEB;
				}
			}
		}
	}
	//块2
	.block_2{
		overflow: hidden;
		position: relative;
		.block_2_main{
			width: 1140px;
			margin: 0 auto;
			padding: 60px 0 0px 0;
			.msg_box{
				margin-top: 30px;
				padding: 20px 40px;
				border-radius: 24px;
				border: 1px solid #000000;
				.msg_el{
					display: flex;
					align-items: baseline;
					padding-bottom: 10px;
					.txt{
						flex: 1;
						padding-left: 10px;
						span{
							font-weight: bold;
							font-size: 30px;
							color: #000000;
						}
						font-size: 30px;
						font-weight: normal;
						color: #333333;
					}
					.tips{
						position: relative;
						top: 5px;
						font-size: 50px;
						font-weight: bold;
					}
				}
			}
			.title_box{
				display: flex;
				align-items: center;
				.title{
					width: auto;
					font-size: 32px;
					color: rgb(241, 96, 0);
					font-weight: bold;
				}
				.tips{
					flex: 1;
					padding-left: 30px;
					font-size: 30px;
					color: #EBEBEB;
				}
			}
		}
	}
	//块1
	.block_1{
		background-color: #b3d2e9;
		.block_1_main{
			padding: 70px 0;
			.list_box{
				display: flex;
				justify-content: center;
				.list_el{
					width: auto;
					padding: 0 50px;
					text-align: center;
					div{
						padding-top: 10px;
						font-size: 30px;
						color: #016bb8;
					}
					img{
						width: 96px;
					}
				}
			}
		}
	}
	//banner
	.banner_box{
		position: relative;
		.banner_main{
			width: 1140px;
			margin: 0 auto;
			padding: 70px 0 20px 0;
			position: relative;
			.rz{
				position: absolute;
				z-index: 1;
				top: 100px;
				right: -80px;
				width: 210px;
			}
			.banner_main_main{
				display: flex;
				padding-top: 5px;
				.left{
					flex: 1;
					padding-right: 30px;
					.btn_box{
						padding-top: 40px;
						img{
							width: 210px;
							cursor: pointer;
						}
					}
					.list_box{
						display: flex;
						align-items: center;
						.list_el{
							display: flex;
							align-items: center;
							padding-right: 30px;
							div{
								position: relative;
								top: 2px;
								padding-left: 10px;
								font-size: 20px;
							}
							img{
								width: 30px;
							}
						}
					}
					.desc{
						padding: 20px 0 25px 0;
						font-size: 24px;
						line-height: 1.5;
						color: #666;
					}
					.title{
						font-size: 34px;
						color: rgb(241, 96, 0);
					}
				}
				.right{
					flex: 1;
					padding: 0 70px 0 50px;
				}
			}
			.top{
				.tit2{
					font-size: 55px;
					color: rgb(241, 96, 0);
				}
				.tit1{
					font-size: 55px;
				}
			}
		}
	}
	//引导块
	.tips_box{
		padding: 50px 0 30px 0;
		background: linear-gradient(to right, #F2F7FD, transparent);
		.tips_main{
			width: 1140px;
			margin: 0 auto;
			font-size: 18px;
			span{
				color: #0B318F;
				font-size: 18px;
			}
		}
	}
	.icon{
		position: absolute;
	}
}
</style>
<style scoped>
@font-face {
	font-family: 'Impact';
	src: url('../../assets/fonts/Impact.ttf');
}
@font-face {
	font-family: 'Inter';
	src: url('../../assets/fonts/Inter.ttf');
}
.font1{
	font-family: 'Inter';
	font-weight: bold;
}
.font2{
	font-family: 'Impact';
	position: relative;
	top: 3px;
}
>>> .block_7 .el-collapse{
	border: none;
	/* border-bottom: 1px solid #999999; */
}
>>> .block_7 .van-collapse-item{
	border-bottom: 1px solid #999999;
}
>>> .table_box .el-table .cell{
	color: #000000;
	font-size: 20px;
}
>>> .table .el-table th.el-table__cell{
	font-weight: bold;
}
>>> .table_box .el-table .el-table__cell{
	padding: 24px 0;
}
</style>